import React, {useRef} from 'react';

import {TextTableColumn} from "../Tables/TextTableColumn";
import {ActionTableColumn} from "./ActionTableColumn";
import {FileTableColumn} from "./FileTableColumn";
import {ContextNodesTableColumn} from "./ContextNodesTableColumn";
import {TagTableColumn} from "./TagTableColumn";
import {StreamBankTable} from "../Table/StreamBankTable";
import {DateTableColumn} from "../Tables/DateTableColumn";
import {UserTableColumn} from "../Tables/UserTableColumn";

export const FileBrowserTable = React.forwardRef((props, ref) => {
    
    const columnDefs = [
        {
            title: "Name",
            key: "name",
            sortable: true,
            logic: (x) => x.name,
            headerClassName: "filename",
            renderer: FileTableColumn,
            customData: {
                ReloadData: () => ref?.current?.props?.ReloadData()
            }
        },
        {
            title: "Context",
            key: "fileName",
            sortable: true,
            headerClassName: "context",
            logic: (x) => x?.FileUploadContextNodes.map(x => x?.ContextNode),
            renderer: ContextNodesTableColumn,
        },
        {
            title: "Tags",
            key: "tagId",
            sortable: true,
            logic: (x) => x.FileUploadTag?.length ? x.FileUploadTag : '',
            headerClassName: "tags",
            renderer: TagTableColumn,
            customData: {
                AddToSearch: (text) => {
                    const {AddToSearch} = props;

                    if (AddToSearch) {
                        AddToSearch(text);
                    }
                }
            }
        },
        {
            title: "Uploaded By",
            key: "userId",
            sortable: true,
            headerClassName: "username",
            logic: (x) => x?.User?.userId,
            renderer: UserTableColumn
        },
        {
            title: "Upload Date",
            key: "created",
            sortable: true,
            logic: (x) => x.created,
            headerClassName: "short-date",
            renderer: DateTableColumn
        },
        {
            title: "Action",
            key: "action",
            sortable: false,
            logic: (x) => x,
            cellClassName: "actions-cell",
            headerClassName: "actions-cell",
            renderer: ActionTableColumn,
            customData: {
                ReloadData: () => props?.ReloadData()
            }
        }
    ];

    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="files"
        getKeyForRow={x => x.fileUploadId}

        sortColumn="created"
        sortAsc={false}
        
        ref={ref}

        {...props}

    />
});
